import { useMutation, useQueryClient } from "@tanstack/react-query";
import { getUsersApiClient } from "@shared/apis/sidekick/api-factories";
import { GET_USER_PROFILE_QUERY_KEY } from "./useGetUserProfile";
import { toast } from "@shared/services/toast";

type UseEditUserProfileProps = {
  onSuccess?: (data: Params) => void;
};

type Params = {
  name: string;
  timezone?: string;
  countryState?: string;
  country?: string;
  phoneNumber?: string | null;
  officeName: string;
  website?: string | null;
};

export const useEditUserProfile = (props?: UseEditUserProfileProps) => {
  const { onSuccess } = props || {};
  const api = getUsersApiClient();
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: async (params: Params) => {
      const response = await api.userControllerUpdateProfile({
        updateMyProfileRequest: {
          name: params.name,
          timezone: params.timezone,
          countryState: params.countryState,
          country: params.country,
          phoneNumber: params.phoneNumber ?? "",
          officeName: params.officeName,
          website: params.website ?? null,
        },
      });
      queryClient.invalidateQueries({ queryKey: [GET_USER_PROFILE_QUERY_KEY] });
      onSuccess?.(params);
      // toast.success("Profile saved", { toastId: "user-profile-saved" });
      return response;
    },
    onError: (error) => {
      toast.error("Failed to update profile.");
      console.error(`Failed to update profile`, error);
    },
    mutationKey: ["edit-user-profile"],
  });

  return mutation;
};
